export default __webpack_public_path__ + "static/media/UZB.daa5dcd3.svg";